/** Landing toolbar CTA for roster / multi-person exclusion checks (#10124). */
export const BULK_ADVERSE_CHECK_BUTTON_LABEL = "Bulk adverse check";

/**
 * Legacy New-check toolbar CTA — removed; History tab owns download (#10147).
 * Kept as a sentinel so tests can assert it must not reappear on New check.
 */
export const REMOVED_NEW_CHECK_DOWNLOAD_HISTORY_LABEL = "Download History";
